// This is how a normal module looks like. You can copy paste this
// for any new module you want to create. Then you can import it in
// main.js and call "init()" to execute the code.


const GallerySlider = ((($) => {
  let slide_id;
  let slider;
  let slide_name;
  let current_slide_name;
  //let slider_captions;
  function init() {
    slider = $('.js-slider');
    //slider_captions = $('.captions-slider');
    slider.slick({
      dots: false,
      infinite: true,
      speed: 800,
      autoplay: false,
      autoplaySpeed: 4000,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,

    });

    // slider_captions.slick({
    //   dots: false,
    //   infinite: true,
    //   speed: 800,
    //   autoplay: true,
    //   autoplaySpeed: 4000,
    //   slidesToShow: 1,
    //   slidesToScroll: 1,
    //   arrows: false,
    //   fade: true,
    //   asNavFor: '.js-carousel',
    //   adaptiveHeight: true
    // });

    //
    $('.js-carousel_l').click( function(e) {
      e.preventDefault();
      $(this);
      $('.js-slider').slick('slickPrev');
    });

    $('.js-carousel_r').click( function(e) {
      e.preventDefault();
      $(this);
      $('.js-slider').slick('slickNext');
    });

    $('.control-icon').on('click', function() {
      $('.control-icon').not(this).removeClass('active');
      $(this).addClass('active');
      slide_name = $(this).data('slide');
      slide_id = slider.find('[data-slide="'+slide_name+'"]').parents('.slick-slide:not(.slick-cloned)').data('slick-index');
      slider.slick('slickGoTo', parseInt(slide_id));
    });



    slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      $(this);
      $('.curr').text(nextSlide + 1);

    });

    slider.on('afterChange', function() {
      $(this);
      $('.control-icon').removeClass('active');
      current_slide_name = $('.slick-current').find('.Carousel-item').data('slide');
      $('.Carousel-controls').find('.control-icon[data-slide="'+current_slide_name+'"]').addClass('active');
    });

  }

  return {
    init,
  };
}))(jQuery);

export default GallerySlider;



// WEBPACK FOOTER //
// ./src/static/js/modules/gallery-slider.js